<div *ngIf="!appointment && webCallBackMedical">
    <div class="recap-container">
        <div class="recap-container__header">
            <div class="recap-container__header__title recap-container__header__title--webcallback">
                <span class="recap-container__header__title recap-container__header__title--left gutter-mobile-bottom">
                    <img data-cand-image="assets/images/calendar-green.svg" alt="" class="recap-container__header__title__icon-calendar" [appAssetSrc]="'assets/images/calendar-green.svg'" />
                    {{ 'documentselection.recapappointment.header.title' | i18n }}
                </span>
                <img class="recap-container__header__title__arm-image" alt="" data-cand-image="assets/images/logo-ARM.svg" [appAssetSrc]="'assets/images/logo-ARM.svg'" />
            </div>
        </div>
        <div class="recap-container__body">
            <div class="recap-container__body__appointment">
                {{ 'documentselection.documentlist.infowebcallback' | i18n }}
            </div>
        </div>
    </div>
</div>
<div *ngIf="appointment">
    <div class="recap-container">
        <div class="recap-container__header">
            <div class="recap-container__header__title">
                <span class="recap-container__header__title recap-container__header__title--left gutter-mobile-bottom ng-binding">
                    <img class="recap-container__header__title__icon-calendar" alt="" [appAssetSrc]="'assets/images/calendar-green.svg'" />&nbsp;
                    {{ 'documentselection.recapappointment.header.title' | i18n }}
                </span>
                <img class="recap-container__header__title__arm-image" alt="" [appAssetSrc]="'assets/images/logo-ARM.svg'" />
            </div>
        </div>
        <div class="recap-container__body gutter-mobile-bottom">
            <div class="recap-container__body__appointment">{{ appointment?.labelDate }},</div>
            <div class="recap-container__body__appointment">
                {{ appointment?.labelPraticien }}
            </div>
        </div>
        <div class="recap-container__footer">
            <a class="recap-container__body__details" (click)="navigateToAppointmentDetails()"> {{ 'documentselection.recapappointment.body.details' | i18n }}</a>
            <div class="recap-container__footer__buttons">
                <button type="button" data-tag-commander="" [appTagCommander]="'tagCo.documentselection.documentlist.modifyappointment.button'" class="button button--grey button--previous grid-mobile-4" (click)="goToEditRdvMedical()">
                    {{ 'appointment.appointmentconfirmation.button.move-appointment' | i18n }}
                </button>
                <button
                    type="button"
                    data-tag-commander=""
                    [appTagCommander]="'tagCo.documentselection.documentlist.cancelappointment.button'"
                    class="recap-container__footer__buttons__cancel-rdv grid-mobile-4"
                    (click)="toogleModalRdvMedical.emit(true)"
                >
                    {{ 'appointment.appointmentconfirmation.cancel.text' | i18n }}
                </button>
            </div>
        </div>
    </div>
</div>
